export const settings = {
    buttonSize: 15,
    expand: 10,
};
